"use client";

import { useEffect } from "react";
import { HeroLogoMark } from "./HeroLogoMark";

export type HeroCanvasFallbackProps = {
  className?: string;
  onIntroComplete?: () => void;
};

/** Lightweight fallback when the Three.js hero chunk fails to load. */
export function HeroCanvasFallback({ className, onIntroComplete }: HeroCanvasFallbackProps) {
  useEffect(() => {
    onIntroComplete?.();
  }, [onIntroComplete]);

  return <HeroLogoMark className={className} centered />;
}
